/// <reference path="../../../../node_modules/react-datetime/react-datetime.d.ts" />

import { Translate } from '../../../shared/LanguageService';
import { connect } from 'react-redux';
import { assign } from '../../../shared/Assign';
import { Button, Col } from 'react-bootstrap';
import Calendar from '../../calendar/Calendar';
import ICalendarItem from '../../calendar/Types';
import * as Features from '../../../shared/Features';
import * as React from 'react';
import * as Actions from './actions/ScandphotosPhotographerBookingActions';
import Loader from 'react-loader';
import moment from 'moment';

interface IProps {
    calendar: any;
    orderInfo: any;
    actions: IActions;
    buttonLabel?: string;
    onSelected: (calendarItem: ICalendarItem) => void;
    user: any;
    bookableOnlyBySE360: boolean;
}

class PhotographerBooking extends React.Component<IProps, any> {
    private scandphotosBookingCalendarItemType: number = 1 << 1;
    private cacheDictionary: Object = {};

    constructor(props: IProps, context: any) {
        super(props, context);

        this.state = {
            events: [],
            calendarSettings: null,
            calendar: {
                items: [],
                workingHours: [],
                loading: true
            },
            selectedDate: moment(new Date()),
            selectedItem: {
                id: null
            },
            orderInfo: props.orderInfo
        };

        this.onEventDrop = this.onEventDrop.bind(this);
        this.onEventClick = this.onEventClick.bind(this);
        this.createCalendar = this.createCalendar.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
    }

    getDefaultCalendarSettings() {
        let calendarSettings: any = {
            selectable: true,
            eventRender: (event, element) => {
                element.append(event.description);
            },
            eventConstraint: 'businessHours',
            selectConstraint: 'businessHours',
            selectHelper: true,
            slotLabelFormat: 'HH:mm',
            timeFormat: 'HH:mm',
            minTime: '06:00:00',
            maxTime: '20:00:00',
            defaultView: 'photographerView',
            defaultDate: moment(this.state.selectedDate),
            eventStartEditable: false,
            highlightToday: true,
            disableResizing: true,
            snapDuration: '00:05:00',
            eventClick: this.onEventClick,
            eventResize: () => {},
            views: {
                photographerView: {
                    type: 'agenda',
                    duration: { days: 7 }
                }
            },
            header: {
                left: 'title',
                center: '',
                right: 'prev,next'
            },
            eventDrop: (event, delta, revertFunc) => {
                let dropDate = moment(event.start.format()).add(delta.asHours(), 'h');
                if (event.start.day() !== dropDate.day()) {
                    revertFunc();
                }
                this.onEventDrop(event);
            }
        };
        return calendarSettings;
    }

    onEventClick(event) {
        let calendarSettings = this.state.calendarSettings;
        calendarSettings.eventSources[0].events.forEach((e) => {
            e.color = e.id === event.id ? 'orange' : 'gray';
        });
        this.setState({
            selectedItem: event,
            calendarSettings: calendarSettings
        });
    }

    componentDidMount() {
        this.createCalendar({ items: [] });
    }

    createCalendar(calendar: any) {
        if (calendar === null || !calendar.items) {
            this.setState({
                loading: calendar === null
            });
            return;
        }
        let settings = this.getDefaultCalendarSettings();

        let firstDayOfWeek = moment().startOf('week').day();
        settings.defaultDate =
            moment(settings.defaultDate).day() === firstDayOfWeek
                ? moment(settings.defaultDate).format()
                : moment(settings.defaultDate).day(firstDayOfWeek).format();

        let events = [];
        calendar.items.forEach((e) => {
            let evt = e;
            evt.id = evt.uniqueId;
            evt.editable = true;
            evt.disableClick = true;
            events.push(evt);
        });

        settings.eventSources = [
            {
                events: events
            }
        ];
        settings.eventColor = 'gray';
        calendar.items = events;

        this.setState({
            calendarSettings: settings,
            calendar: calendar,
            events: events,
            loading: false
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any, nextState: any) {
        this.createCalendar(assign([], nextProps.calendar));
    }

    onEventDrop(event: any) {
        let calendarList = this.state.calendarList;
        let selectedItem = this.state.selectedItem;

        calendarList.forEach((calendar) => {
            calendar.eventSources[0].events
                .filter((item) => {
                    return item.id > 0;
                })
                .forEach((item) => {
                    if (item.id === event.id) {
                        item.start = event.start.format();
                        item.end = event.end.format();
                        if (item.id === selectedItem.id) {
                            selectedItem.start = item.start;
                            selectedItem.end = item.end;
                        }
                    }
                });
        });

        this.setState({
            calendarList: calendarList,
            selectedItem: selectedItem
        });
    }

    onDateChange(value: any) {
        let selectedDate = this.state.selectedDate;
        let currentWeek = moment().week();
        let selectedWeek = value.week();
        if (
            (selectedWeek >= currentWeek || value.unix() > moment().unix()) &&
            (selectedWeek !== selectedDate.week() ||
                !this.cacheDictionary.hasOwnProperty(selectedWeek))
        ) {
            this.cacheDictionary[selectedWeek] = 1;
            let executionTime: number = this.props.orderInfo.product.executionTime;

            this.props.orderInfo.additionalProducts.forEach((x) => {
                executionTime += x.executionTime;
            });

            this.setState({
                selectedDate: value,
                loading: true
            });

            let productIds = this.props.orderInfo.additionalProducts.map((x) => {
                return x.id;
            });
            if (this.props.orderInfo.product.id) {
                productIds.push(this.props.orderInfo.product.id);
            }

            this.props.actions.getPhotographers(
                value.year(),
                value.month() + 1,
                value.date(),
                this.props.orderInfo.address,
                this.props.orderInfo.postalCode,
                this.props.orderInfo.city,
                this.props.orderInfo.addressPointLocation
                    ? this.props.orderInfo.addressPointLocation.longitude
                    : null,
                this.props.orderInfo.addressPointLocation
                    ? this.props.orderInfo.addressPointLocation.latitude
                    : null,
                executionTime,
                this.props.orderInfo.additionalProducts.map((x) => {
                    return x.name;
                }),
                productIds,
                this.props.orderInfo.brokerFirmRegionId,
                this.props.orderInfo.brokerFirmId,
                this.props.orderInfo.orderId,
                this.props.orderInfo.numberOfMeasuredPlans
            );
        }
    }

    bookPhotographer(item) {
        let calendarItem: any = {
            allDay: false,
            description: item.description,
            editable: true,
            end: item.end.toDate(),
            start: item.start.toDate(),
            id: null,
            orderId: item.orderId,
            userId: item.userId,
            photographerName: item.photographerName,
            title: item.title,
            type: this.scandphotosBookingCalendarItemType,
            productProperties: null
        };
        this.props.onSelected(calendarItem);
    }

    render() {
        return (
            <fieldset>
                <div>
                    {this.state.loading && (
                        <div style={{ height: '50vh' }}>
                            <Loader loaded={!this.state.loading}></Loader>
                        </div>
                    )}
                    {!this.state.loading && (
                        <div>
                            <Col sm={9}>
                                {this.state.calendarSettings !== null &&
                                    !this.state.loading &&
                                    (this.props.bookableOnlyBySE360
                                        ? Features.hasFeature(
                                              Features.BookOrdersWithoutTraveltime,
                                              this.props.user
                                          )
                                        : true) && (
                                        <Calendar
                                            settings={this.state.calendarSettings}
                                            calendarItems={null}
                                            workingHours={null}
                                            onChange={(items) => {}}
                                            onDeleted={(e) => {}}
                                            onUpdated={(e) => {}}
                                            onCreated={(e) => {}}
                                            onRangeChanged={(from) => this.onDateChange(from)}
                                            user={this.props.user}
                                        />
                                    )}
                                {this.state.calendarSettings !== null &&
                                    !this.state.loading &&
                                    (this.props.bookableOnlyBySE360
                                        ? Features.hasNotFeature(Features.ViewLogs, this.props.user)
                                        : '') && (
                                        <div>
                                            <h1>
                                                <i className="material-icons material-icons-info no-label md-60">
                                                    warning
                                                </i>{' '}
                                                {Translate(
                                                    'scandphotos/photographerbooking/page/header/bad-traveltimes-let-scandphotos-book'
                                                )}
                                            </h1>
                                        </div>
                                    )}
                            </Col>
                            <Col sm={3}>
                                {this.state.selectedItem.id !== null && (
                                    <div>
                                        <h1>{this.state.selectedItem.start.format('L')}</h1>
                                        <h3>
                                            {moment(this.state.selectedItem.start).format('LT')} -{' '}
                                            {moment(this.state.selectedItem.end).format('LT')}
                                        </h3>
                                        <h4>
                                            {Translate(
                                                'scandphotos/photographerbooking/page/text/travel-time'
                                            )}
                                            : {this.state.selectedItem.travelTime}{' '}
                                            {Translate(
                                                'scandphotos/photographerbooking/page/text/minutes'
                                            )}
                                        </h4>
                                        <Button
                                            bsStyle="primary"
                                            bsSize="lg"
                                            disabled={this.state.selectedItem.id === null}
                                            onClick={() => {
                                                this.bookPhotographer(this.state.selectedItem);
                                            }}
                                            block
                                        >
                                            {this.props.buttonLabel
                                                ? this.props.buttonLabel
                                                : Translate(
                                                      'scandphotos/photographerbooking/page/button/next'
                                                  )}
                                        </Button>
                                    </div>
                                )}
                                {this.state.selectedItem.id === null &&
                                    this.state.calendar.items.length > 0 && (
                                        <div>
                                            <h1>
                                                {Translate(
                                                    'scandphotos/photographerbooking/page/text/choose-time-slot'
                                                )}
                                            </h1>
                                        </div>
                                    )}
                                {this.state.calendar.items.length === 0 && (
                                    <div>
                                        <h1>
                                            {Translate(
                                                'scandphotos/photographerbooking/page/header/no-photographers'
                                            )}
                                        </h1>
                                        <h3>
                                            {Translate(
                                                'scandphotos/photographerbooking/page/description/no-photographers'
                                            )}
                                        </h3>
                                    </div>
                                )}
                                {this.state.calendar.items.length === 0 && (
                                    <div>
                                        <Button
                                            bsStyle="info"
                                            bsSize="lg"
                                            onClick={() => {
                                                this.props.onSelected(null);
                                            }}
                                            block
                                        >
                                            {Features.hasFeature(
                                                Features.EditPhotographerBookingExecutionTime,
                                                this.props.user
                                            )
                                                ? Translate(
                                                      'scandphotos/orders/create/photographer-booking/button/cancel'
                                                  )
                                                : Translate(
                                                      'scandphotos/orders/create/photographer-booking/button/skip-booking'
                                                  )}
                                        </Button>
                                    </div>
                                )}
                            </Col>
                        </div>
                    )}
                </div>
            </fieldset>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        calendar: state.ScandphotosPhotographerBooking.calendar,
        orderInfo: ownProps.orderInfo,
        user: state.user,
        bookableOnlyBySE360: state.ScandphotosPhotographerBooking.bookableOnlyBySE360
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getPhotographers: (
                year: number,
                month: number,
                day: number,
                address: string,
                postalCode: string,
                city: string,
                addressPointLocationLongitude: number,
                addressPointLocationLatitude: number,
                product: number,
                additionalProducts: string[],
                productIds: number[],
                brokerFirmRegionId: number,
                brokerFirmId: number,
                orderId?: number,
                numberOfMeasuredPlans?: number
            ) =>
                dispatch(
                    Actions.getPhotographerCalendars(
                        year,
                        month,
                        day,
                        address,
                        postalCode,
                        city,
                        addressPointLocationLongitude,
                        addressPointLocationLatitude,
                        product,
                        additionalProducts,
                        productIds,
                        brokerFirmRegionId,
                        brokerFirmId,
                        orderId,
                        numberOfMeasuredPlans
                    )
                ),
            updatePhotographer: (calendarItem: any) =>
                dispatch(Actions.updatePhotographer(calendarItem))
        }
    };
}

interface IActions {
    getPhotographers: (
        year: number,
        month: number,
        day: number,
        address: string,
        postalCode: string,
        city: string,
        addressPointLocationLongitude: number,
        addressPointLocationLatitude: number,
        product: number,
        additionalProducts: string[],
        productIds: number[],
        brokerFirmRegionId: number,
        brokerFirmId: number,
        orderId?: number,
        numberOfMeasuredPlans?: number
    ) => any;
    updatePhotographer: (calendarItem: any) => any;
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotographerBooking);
